import { render, staticRenderFns } from "./dialog-2-1.vue?vue&type=template&id=2dc9197c&scoped=true&"
import script from "./dialog-2-1.vue?vue&type=script&lang=ts&"
export * from "./dialog-2-1.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-2-1.vue?vue&type=style&index=0&id=2dc9197c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc9197c",
  null
  
)

export default component.exports